export const settingsList: any[] = [
  {
    challengeName: 'Match outcome',
    key: 'FULL_TIME_WINNER',
    label: 'Match outcome coefficient',
    data: {
      value: '',
      energyPrice: ''
    }
  },
  {
    challengeName: 'Half-time winner',
    key: 'HALF_TIME_WINNER',
    label: 'Half-time winner coefficient',
    data: {
      value: '',
      energyPrice: ''
    }
  },
  {
    challengeName: 'Goals total',
    key: 'GOALS_TOTAL',
    label: 'Goals total coefficient',
    data: {
      value: '',
      energyPrice: ''
    }
  },
  {
    challengeName: 'Energy accruals',
    key: 'ENERGY_ACCRUALS',
    label: 'Energy refil minutes',
    data: {
      minutesToAddOneEnergy: 0
    }
  },
  {
    challengeName: 'Full-time score',
    key: 'FINAL_SCORE',
    label: 'Full-time score coefficient',
    data: {
      value: '',
      energyPrice: '',
      frequencies: [
        {score: '0-0', coefficient: 3.1},
        {score: '1-0; 0-1', coefficient: 4.2},
        {score: '2-0; 0-2', coefficient: 6.7},
        {score: '3-0; 0-3', coefficient: 12.3},
        {score: '4-0; 0-4', coefficient: 25.4},
        {score: '5-0; 0-5', coefficient: 50.8},
        {score: '1-1', coefficient: 2.3},
        {score: '2-1; 1-2', coefficient: 5.6},
        {score: '3-1; 1-3', coefficient: 13.5},
        {score: '4-1; 1-4', coefficient: 23.9},
        {score: '5-1; 1-5', coefficient: 45.1},
        {score: '2-2', coefficient: 5.9},
        {score: '3-2; 2-3', coefficient: 13.5},
        {score: '4-2; 2-4', coefficient: 27.1},
        {score: '5-2; 2-5', coefficient: 81.2},
        {score: '3-3', coefficient: 17.6},
        {score: '4-3; 3-4', coefficient: 45.1},
        {score: '5-3; 3-5', coefficient: 135.3},
        {score: '4-4', coefficient: 66},
      ],
      defaultFrequencyCoefficient: 160
    }
  }
]